import React from "react";
import hiveSettingEnImg from "../../assets/images/screenshots/hive_account_setting_en.jpeg";
import hiveSettingKoImg from "../../assets/images/screenshots/hive_account_setting_ko.jpeg";
import rewardClaim1EnImg from "../../assets/images/screenshots/reward_claim_1_en.jpeg";
import rewardClaim1KoImg from "../../assets/images/screenshots/reward_claim_1_ko.jpeg";
import rewardClaim2EnImg from "../../assets/images/screenshots/reward_claim_2_en.jpeg";
import rewardClaim2KoImg from "../../assets/images/screenshots/reward_claim_2_ko.jpeg";

export type Lang = "ko" | "en";

export const navItemsByLang: Record<Lang, { label: string; href: string }[]> = {
    ko: [
        { label: "여행 & 보상", href: "#features" },
        { label: "장소증인", href: "#witness" },
        { label: "Hive 보상", href: "#earn" },
        { label: "FAQ", href: "#faq" },
        { label: "문의하기", href: "#contact" },
    ],
    en: [
        { label: "Travel & Earn", href: "#features" },
        { label: "Place Witness", href: "#witness" },
        { label: "Hive Rewards", href: "#earn" },
        { label: "FAQ", href: "#faq" },
        { label: "Contact", href: "#contact" },
    ],
};

export const i18n = {
    ko: {
        hero: {
            badge: "진짜 여행자를 위한 진짜 지도",
            titleLine1: "여행하고, 기록하고, 보상받자 —",
            titleHighlight: "Percent Map에서",
            btn1: "앱 다운로드",
            btn2: "보상 시스템 알아보기",
            tag1: "Hive 보상 + Witness NFT",
            tag2: "컬렉션 공유",
        },
        features: {
            kicker: "TRAVEL & EARN",
            title: "여행 기록이 곧 가치가 됩니다",
            subtitle:
                "여행 중 남긴 포스트는 지도 위에 쌓이고, 반응(좋아요·큐레이션)은 보상으로 연결됩니다.",
            card1Title: "여행하며 기록",
            card1Desc:
                "여행 중 바로 게시물을 남기고, 장소와 연결된 경험을 지도 위에 기록합니다.",
            card2Title: "반응이 쌓이면",
            card2Desc:
                "반응(좋아요·큐레이션)이 쌓일수록 '좋은 여행 정보'라는 신호가 강화되고, 보상으로 이어집니다.",
            adFreeTitle: "광고 없는 피드",
            adFreeDesc:
                "Percent Map은 광고 수익에 의존하지 않습니다. 조회수 중심의 자극보다, 여행을 사랑하는 사람에게 의미 있는 기록을 우선합니다.",
            adFreeTag: "No ads · No bait",
            hiveTitle: "Hive 기반 보상 시스템",
            hiveDesc:
                "보상은 Hive 블록체인 기반 메커니즘에서 나옵니다. 그래서 포스트는 소비 대상이 아니라, 함께 쌓아가는 여행 자산이 됩니다.",
            rewardSignal: "Reward signal",
            reactions: "Reactions",
            longTerm: "Long-term",
            valueAccrues: "Value accrues",
            quoteMain:
                "광고가 아니라, 여행을 사랑하는 사람들이 만든 지도가 보상받습니다.",
            quoteSub:
                "여행 기록이 쌓일수록, 당신의 신뢰와 영향력도 함께 성장합니다.",
        },
        rewards: {
            kicker: "REWARDS",
            titlePre: "여행 기록이 ",
            titleHighlight: "보상이 됩니다",
            authorBadge: "Author",
            authorTitle: "저자 보상",
            authorDesc:
                "여행 게시물이 반응(좋아요·큐레이션)을 받을수록, 게시물을 작성한 저자에게 보상이 발생합니다.",
            authorFoot: "작성자에게 돌아가는 보상",
            curatorBadge: "Curator",
            curatorTitle: "큐레이션 보상",
            curatorDesc:
                "반응(좋아요·큐레이션)으로 좋은 여행 정보를 발견한 사용자에게도 보상이 주어집니다.",
            curatorFoot: "큐레이터에게도 보상",
            witnessBadge: "Place Witness",
            witnessTitle: "Place Witness 보너스 + Witness NFT",
            witnessDesc:
                "특정 장소를 가장 잘 기록한 여행자는 Place Witness로 선정되어 추가 보상과 Witness NFT를 받습니다.",
            howItWorks: "How it works",
            step1Title: "여행하며 기록",
            step1Desc: "장소 · 사진 · 경험을 포스트로 남깁니다.",
            step2Title: "반응(좋아요·큐레이션)",
            step2Desc:
                '반응이 쌓이며 "좋은 여행 정보" 신호가 강화됩니다.',
            step3Title: "보상 + Place Witness(장소증인)",
            step3Desc:
                "저자/큐레이터 보상 + 선정 시 Witness NFT를 받습니다.",
            note: "Hive Sync가 활성화된 경우 게시물은 Hive 블록체인에 기록되며, 외부 서비스(hive.blog 등)에 공개될 수 있습니다. 블록체인 특성상 기록은 영구적일 수 있으며 삭제가 제한될 수 있습니다.",
        },
        witness: {
            kicker: "PLACE WITNESS",
            title: "장소를 대표하는 여행자",
            subtitle:
                "좋은 여행 게시물에 쌓인 반응(좋아요·큐레이션)이 그 장소의 Place Witness(장소증인)를 만듭니다.",
            selectedBy: "반응(좋아요·큐레이션)으로 선정",
            witnessH3: "Place Witness",
            witnessH3Sub: "(장소증인)",
            nftBadgeTag: "NFT badge on the map",
            selectionNote: "* 선정 기준은 정책에 따라 변경 가능",
            compTitle: "경쟁 · 레벨 · 유효기간",
            validBadge: "Valid 1 year*",
            levels: "LEVELS",
            defenseLabel: "Defense gets harder ↑",
            nftCardTitle: "Witness NFT 카드",
            physicalCard: "Physical card (planned)",
            nftCardDesc:
                'Witness NFT는 한 장소를 대표하는 여행자의 순간을 담은 디지털 컬렉션 카드입니다. 앞으로는 디지털 카드와 연결된 실물 카드로도 발급할 수 있으며, 사용자 간 카드 트레이딩 기능으로 확장될 예정입니다. 카드 뒷면의 QR 코드를 통해 누구나 진위를 확인할 수 있고, 지도 위에서는 NFT 배지로 표시됩니다. 여행의 추억을 세상에 하나뿐인 카드와 함께 간직해보세요.',
            example: "Example",
            eiffelTower: "Eiffel Tower",
            newWitness: "New witness",
            reactionsLabel: "반응(좋아요·큐레이션)",
            enough: "Enough",
            minted: "Minted",
            internalNote:
                "내부적으로는 반응이 점수로 환산되어 선정 기준에 사용됩니다.",
        },
        earn: {
            kicker: "FOR HIVE USERS",
            title: "하이브 유저에게 건네는 퍼센트맵의 제안",
            subtitle: "좋은 게시물의 보상이 7일로 끝날 필요 없습니다. 퍼센트맵에서는 좋아요가 이어지는 한 보상도 계속 쌓입니다.",
            step1Tag: "보상 누적",
            step1Title: "좋아요가 쌓일수록 Hive가 쌓입니다",
            step1Desc: "내 게시물에 좋아요가 달릴 때마다 Hive 보상이 누적됩니다. 게시물이 살아있는 한 보상도 계속 이어져요.",
            step1Hint: "하이브 계정을 퍼센트맵과 연결하고 좋아요를 받으면 Hive 보상이 지속적으로 쌓입니다.",
            step2Tag: "리워드 Claim",
            step2Title: "쌓인 Hive, 원할 때 내 지갑으로",
            step2Desc: "프로필 → 리워드 탭에서 누적된 Hive를 확인하고, Claim하면 4주 이내로 내 Hive 지갑으로 전송됩니다.",
        },
        faq: {
            kicker: "FAQ",
            title: "자주 묻는 질문",
            subtitle: "초기 유저가 가장 궁금해하는 것부터.",
        },
        contact: {
            kicker: "CONTACT",
            title: "문의하기",
            subtitle: "궁금한 점이 있으시면 언제든지 연락주세요.",
            emailLabel: "회신 받을 이메일",
            emailPlaceholder: "your@email.com",
            subjectLabel: "제목",
            subjectPlaceholder: "문의 제목을 입력해주세요",
            contentLabel: "내용",
            contentPlaceholder: "문의 내용을 자세히 입력해주세요",
            submit: "문의 보내기",
            sending: "전송 중...",
            successTitle: "문의가 접수되었습니다",
            successBody: "빠른 시일 내에 입력하신 이메일로 회신드리겠습니다.",
            errorTitle: "전송에 실패했습니다",
            errorBody: "잠시 후 다시 시도해주세요.",
            required: "필수 항목을 모두 입력해주세요.",
        },
        footer: {
            tagline: "Real Map for Real Travelers",
        },
        // i18n.ko 아래에 추가
        legal: {
            common: {
                privacyTitle: "개인정보처리방침",
                termsTitle: "이용약관",
                effectiveDateLabel: "시행일",
                lastUpdatedLabel: "최종 수정일",
                contactLabel: "문의",
                contactEmail: "support@percentmap.com",
                langKo: "KOR",
                langEn: "ENG",
            },
            privacy: {
                intro:
                    "본 방침은 Percent Map(이하 “서비스”)이 이용자의 개인정보를 처리하는 기준을 설명합니다.",
                sections: [
                    {
                        title: "1. 수집하는 개인정보 항목",
                        body: [
                            "계정·프로필: Firebase 사용자 식별자, 이메일, 이름, 계정명, 프로필 사진, 로그인 방식(이메일·Google·Apple·Facebook).",
                            "위치정보: 지도, 주변 장소 및 게시물 위치 연결 기능 제공을 위해 이용자 동의 시 위치와 장소 정보를 처리합니다.",
                            "이용자 콘텐츠: 게시물, 댓글, 사진, 좋아요, 컬렉션, 신고 및 서비스 이용 기록을 처리합니다.",
                            "Hive 연동(선택): 보상 및 동기화 기능을 위해 Hive 계정 정보 및 Hive Private Key 등 키 정보를 입력/수집할 수 있습니다.",
                            "기기/이용기록: 푸시 알림 토큰, 접속 로그, 기기 정보, 오류 및 보안 기록이 생성·수집될 수 있습니다.",
                            "고객지원: 문의 또는 계정 삭제 요청 시 회신 이메일, 계정명, 로그인 방식과 요청 내용을 처리합니다.",
                        ],
                    },
                    {
                        title: "2. 개인정보의 이용 목적",
                        body: [
                            "회원 식별 및 로그인 처리, 계정 관리",
                            "지도 기반 기능 제공(위치 기반 포스트/장소 연결 등)",
                            "Hive 연동 및 보상 지급 처리(내부 로직 및 Hive 메커니즘)",
                            "서비스 안정성/보안/부정 이용 방지",
                            "고객 문의 응대 및 공지 전달",
                        ],
                    },
                    {
                        title: "3. Hive(블록체인) 특성에 대한 고지",
                        body: [
                            "Hive Sync를 활성화하면 게시물이 Hive 블록체인에 기록될 수 있습니다.",
                            "블록체인 특성상 기록은 영구적일 수 있으며, 삭제 또는 수정이 제한될 수 있습니다.",
                            "동기화된 게시물은 hive.blog 등 외부 서비스에 노출될 수 있으며, 이용자가 의도하지 않았더라도 공개될 수 있습니다.",
                        ],
                    },
                    {
                        title: "4. Hive Key 보관 및 보호",
                        body: [
                            "서비스는 Hive Private Key 등 민감한 키 정보를 서버 DB에 암호화하여 저장합니다.",
                            "키 정보는 서비스 제공(연동/서명/보상 처리 등)에 필요한 범위에서만 사용됩니다.",
                            "이용자는 언제든 연동 해제 또는 키 삭제를 요청할 수 있으며, 다만 블록체인에 기록된 데이터 자체는 삭제가 제한될 수 있습니다.",
                        ],
                    },
                    {
                        title: "5. 제3자 서비스 및 처리위탁",
                        body: [
                            "Firebase(Google): 인증, 푸시 알림 및 서비스 운영에 사용합니다.",
                            "Google·Apple·Facebook: 이용자가 선택한 소셜 로그인 인증에 사용합니다.",
                            "Google Maps Platform: 지도, 장소 검색 및 위치 기반 화면 제공에 사용합니다.",
                            "AWS(S3·SES 등): 이미지 저장과 고객지원 이메일 전송 등 인프라 운영에 사용합니다.",
                            "Hive·Steem 블록체인: 이용자가 연동 또는 동기화를 선택한 경우 콘텐츠와 보상 관련 거래를 처리합니다.",
                            "OpenAI: 이용자가 해당 생성 기능을 사용하는 경우 입력 내용과 생성 요청을 처리할 수 있습니다.",
                            "각 제공자는 자신의 개인정보처리방침과 적용 법령에 따라 데이터를 처리할 수 있습니다.",
                        ],
                    },
                    {
                        title: "6. 보상 지급 및 정책 변경",
                        body: [
                            "보상은 Hive 보상 발생 시 내부 로직에 의거하여 지급될 수 있습니다.",
                            "Hive 계정 연동 시, Hive의 메커니즘에 의해 보상이 자동 지급될 수 있습니다.",
                            "정책 변경은 서비스 웹사이트(홈페이지)에 게시하여 고지하며, 문의는 아래 이메일로 가능합니다.",
                        ],
                    },
                    {
                        title: "7. 보관 기간 및 파기",
                        body: [
                            "운영 DB의 계정·프로필·이메일·위치·사진·푸시 토큰과 게시물·댓글 등 계정 연계 데이터는 회원 탈퇴 처리 시 삭제합니다.",
                            "백업 데이터는 삭제 시점부터 최대 30일 이내 순차적으로 소멸합니다.",
                            "접속·보안 로그는 보안과 부정 이용 방지를 위해 최대 90일 보관합니다.",
                            "계정 삭제 요청 및 처리 기록은 요청 이행과 분쟁 대응을 위해 1년간 보관합니다.",
                            "관계 법령에 별도 보관 의무가 있는 경우 해당 데이터만 분리하여 법정 기간 동안 보관합니다.",
                            "Hive·Steem 블록체인에 이미 기록된 데이터는 기술적 특성상 삭제되지 않을 수 있습니다.",
                        ],
                    },
                    {
                        title: "8. 이용자의 권리와 계정 삭제",
                        body: [
                            "앱 설정에서 직접 계정을 삭제하거나 웹 계정 삭제 요청 페이지(/account-deletion)에서 삭제를 요청할 수 있습니다.",
                            "웹 요청은 본인 확인 후 7일 이내 처리하며 결과를 입력한 이메일로 안내합니다.",
                            "계정 삭제 시 Firebase 인증 계정과 앱 DB의 계정 연계 데이터를 삭제하고, 적용 가능한 제3자 서비스에도 삭제 또는 토큰 철회를 요청합니다.",
                        ],
                    },
                    {
                        title: "9. 개인정보 처리자 및 문의",
                        body: [
                            "개인정보 처리자: John Kim",
                            "개인정보 및 고객지원 문의: support@percentmap.com",
                        ],
                    },
                    {
                        title: "10. 만 14세 미만 아동의 가입 제한",
                        body: [
                            "Percent Map은 만 14세 미만 아동의 회원 가입을 허용하지 않습니다.",
                            "신규 가입 시 입력한 생년월일은 가입 가능 연령 확인에만 사용되며, 서버로 전송하거나 저장하지 않습니다.",
                            "나이를 거짓으로 입력하여 가입한 것이 확인되면 계정 이용이 제한되거나 해지될 수 있습니다.",
                        ],
                    },
                ],
            },
            terms: {
                title: "이용약관",
                updatedAtLabel: "시행일",
                // 시행일은 나중에 실제 날짜로 바꾸면 됨 (예: "2026-02-06")
                updatedAt: "YYYY-MM-DD",

                sections: [
                    {
                        heading: "1. 목적",
                        body: [
                            "본 약관은 Percent Map(이하 “서비스”)이 제공하는 여행 기록, 게시, 지도 기반 기능 및 Hive 연동 서비스의 이용과 관련하여 서비스와 이용자 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.",
                        ],
                    },
                    {
                        heading: "2. 회원 가입 및 로그인",
                        body: [
                            "이용자는 이메일 로그인 또는 소셜 로그인을 통해 회원으로 가입할 수 있습니다.",
                            "회원 가입은 만 14세 이상인 사람만 가능하며, 신규 가입 시 생년월일을 이용해 가입 가능 연령을 확인합니다.",
                            "만 14세 미만이거나 연령 정보를 거짓으로 입력한 경우 가입 또는 계정 이용이 제한될 수 있습니다.",
                            "이용자는 정확하고 최신의 정보를 제공해야 하며, 계정 정보의 관리 및 보안에 대한 책임은 이용자 본인에게 있습니다.",
                            "이용자는 자신의 계정을 타인에게 양도하거나 공유할 수 없습니다.",
                        ],
                    },
                    {
                        heading: "3. 콘텐츠의 게시 및 책임",
                        body: [
                            "이용자가 서비스에 게시한 모든 콘텐츠(텍스트, 이미지, 위치 정보 등)에 대한 책임은 이용자 본인에게 있습니다.",
                            "서비스는 관련 법령을 위반하거나, 타인의 권리를 침해하거나, 서비스 운영 정책에 위배되는 콘텐츠에 대해 사전 통지 없이 삭제, 비공개 처리 또는 이용 제한 조치를 할 수 있습니다.",
                            "서비스는 이용자가 게시한 콘텐츠의 정확성, 신뢰성, 적법성을 보증하지 않습니다.",
                        ],
                    },
                    {
                        heading: "4. Hive 연동 및 온체인 기록 (중요)",
                        body: [
                            "이용자가 Hive 연동 기능을 활성화할 경우, 게시한 콘텐츠 또는 활동 내역은 Hive 블록체인에 기록될 수 있습니다.",
                            "블록체인 특성상 온체인에 기록된 데이터는 영구적으로 보관될 수 있으며, 삭제 또는 수정이 제한될 수 있습니다.",
                            "온체인에 기록된 콘텐츠는 hive.blog 등 외부 서비스에 노출될 수 있으며, 이는 서비스의 관리 및 통제 범위를 벗어납니다.",
                            "이용자는 이러한 블록체인 특성을 충분히 이해하고 동의한 경우에만 Hive 연동 기능을 이용해야 합니다.",
                        ],
                    },
                    {
                        heading: "5. 보상 정책",
                        body: [
                            "서비스 내 보상은 Hive 블록체인에서 발생하는 보상 및 서비스 내부 정책에 따른 로직을 기준으로 산정·지급됩니다.",
                            "Hive 계정을 연동한 경우, 보상은 Hive 블록체인 메커니즘에 따라 자동으로 지급될 수 있습니다.",
                            "보상 정책, 지급 기준 및 방식은 서비스 운영 상황에 따라 변경될 수 있으며, 변경 사항은 서비스 홈페이지를 통해 고지합니다.",
                            "부정 행위, 정책 위반 또는 비정상적인 활동이 확인될 경우, 서비스는 보상 지급 제한, 회수 또는 계정 이용 제한 조치를 취할 수 있습니다.",
                        ],
                    },
                    {
                        heading: "6. @percentmap 서비스 계정을 통한 게시물 활용",
                        body: [
                            "이용자의 게시물은 보상 지급 등 서비스 운영에 필요한 절차를 위해 @percentmap 서비스 계정을 통해 Hive 블록체인에 업로드될 수 있습니다.",
                            "이 과정은 별도로 사전 고지되지 않을 수 있으며, 서비스의 지속적인 보상 메커니즘 운영을 위한 필수적인 절차입니다.",
                            "앱 내 보상 시스템을 이용하는 경우 본 절차에 동의한 것으로 간주하며, 이에 동의하지 않는 경우 서비스 이용이 제한될 수 있습니다.",
                        ],
                    },
                    {
                        heading: "7. 서비스 변경 및 중단",
                        body: [
                            "서비스는 운영상, 기술상 필요에 따라 서비스의 전부 또는 일부를 변경하거나 중단할 수 있습니다.",
                            "서비스의 중요한 변경 또는 중단이 발생하는 경우, 서비스는 사전에 홈페이지 또는 공지사항을 통해 안내합니다.",
                        ],
                    },
                    {
                        heading: "8. 면책",
                        body: [
                            "서비스는 Hive 블록체인 네트워크, 외부 플랫폼 노출, 통신 장애, 제3자의 불법 행위 등 서비스의 통제 범위를 벗어난 사유로 인해 발생한 손해에 대해, 관련 법령이 허용하는 범위 내에서 책임을 제한합니다.",
                            "서비스는 이용자의 선택에 의해 이루어진 Hive 연동 및 온체인 기록으로 인해 발생하는 결과에 대해 책임을 지지 않습니다.",
                        ],
                    },
                    {
                        heading: "9. 준거법 및 분쟁 해결",
                        body: [
                            "본 약관은 대한민국 법령을 준거법으로 합니다.",
                            "서비스와 이용자 간 분쟁이 발생할 경우, 민사소송법에 따른 관할 법원을 따릅니다.",
                        ],
                    },
                    {
                        heading: "10. 회원 탈퇴 및 데이터 삭제",
                        body: [
                            "이용자는 앱 설정 또는 웹 계정 삭제 요청 페이지를 통해 언제든 회원 탈퇴를 요청할 수 있습니다.",
                            "탈퇴 처리 시 프로필, 이메일, 위치, 사진, 푸시 토큰 및 앱 DB의 게시물·댓글 등 계정 연계 데이터를 삭제합니다.",
                            "Hive·Steem 블록체인에 이미 기록된 콘텐츠와 거래는 블록체인의 특성상 삭제 또는 수정이 제한될 수 있습니다.",
                            "구체적인 처리 및 보관 기간은 개인정보처리방침을 따릅니다.",
                        ],
                    },
                    {
                        heading: "11. 시행일",
                        body: ["본 약관은 서비스 홈페이지에 공지한 시행일로부터 적용됩니다."],
                    },
                ],
            }
        },

    },
    en: {
        hero: {
            badge: "Real Map for Real Travelers",
            titleLine1: "Travel. Post. Earn —",
            titleHighlight: "on Percent Map",
            btn1: "Get the app",
            btn2: "See how rewards work",
            tag1: "Hive rewards + Witness NFT",
            tag2: "Collections sharing",
        },
        features: {
            kicker: "TRAVEL & EARN",
            title: "Your Travel Records Become Value",
            subtitle:
                "Posts left during your travels accumulate on the map, and reactions (likes & curation) lead to rewards.",
            card1Title: "Record While Traveling",
            card1Desc:
                "Leave posts during your trips, recording place-connected experiences on the map.",
            card2Title: "As Reactions Accumulate",
            card2Desc:
                "As reactions (likes & curation) build up, the 'good travel info' signal strengthens, leading to rewards.",
            adFreeTitle: "Ad-Free Feed",
            adFreeDesc:
                "Percent Map doesn't rely on ad revenue. Instead of view-driven clickbait, we prioritize meaningful records for those who love travel.",
            adFreeTag: "No ads · No bait",
            hiveTitle: "Hive-Based Reward System",
            hiveDesc:
                "Rewards come from Hive blockchain-based mechanisms. Posts aren't just content to consume — they become shared travel assets you build together.",
            rewardSignal: "Reward signal",
            reactions: "Reactions",
            longTerm: "Long-term",
            valueAccrues: "Value accrues",
            quoteMain:
                "It's not ads — it's a map made by travelers who love travel that gets rewarded.",
            quoteSub:
                "As your travel records grow, so does your trust and influence.",
        },
        rewards: {
            kicker: "REWARDS",
            titlePre: "Travel Records ",
            titleHighlight: "Become Rewards",
            authorBadge: "Author",
            authorTitle: "Author Rewards",
            authorDesc:
                "As your travel posts receive reactions (likes & curation), rewards are generated for the post author.",
            authorFoot: "Rewards returned to the author",
            curatorBadge: "Curator",
            curatorTitle: "Curation Rewards",
            curatorDesc:
                "Users who discover good travel information through reactions (likes & curation) also receive rewards.",
            curatorFoot: "Rewards for curators too",
            witnessBadge: "Place Witness",
            witnessTitle: "Place Witness Bonus + Witness NFT",
            witnessDesc:
                "The traveler who best records a specific place is selected as Place Witness and receives additional rewards and a Witness NFT.",
            howItWorks: "How it works",
            step1Title: "Record While Traveling",
            step1Desc: "Leave posts about places, photos, and experiences.",
            step2Title: "Reactions (Likes & Curation)",
            step2Desc:
                "As reactions build up, the 'good travel info' signal strengthens.",
            step3Title: "Rewards + Place Witness",
            step3Desc:
                "Author/curator rewards + Witness NFT upon selection.",
            note: "When Hive Sync is enabled, posts are recorded on the Hive blockchain and may be publicly visible on external services (e.g. hive.blog). Due to blockchain characteristics, records may be permanent and deletion may be limited.",
        },
        witness: {
            kicker: "PLACE WITNESS",
            title: "The Traveler Who Represents a Place",
            subtitle:
                "Reactions (likes & curation) on great travel posts create the Place Witness for that location.",
            selectedBy: "Selected by reactions (Likes & Curation)",
            witnessH3: "Place Witness",
            witnessH3Sub: "",
            nftBadgeTag: "NFT badge on the map",
            selectionNote: "* Selection criteria may change based on policy",
            compTitle: "Competition · Levels · Validity",
            validBadge: "Valid 1 year*",
            levels: "LEVELS",
            defenseLabel: "Defense gets harder ↑",
            nftCardTitle: "Witness NFT Card",
            physicalCard: "Physical card (planned)",
            nftCardDesc:
                "The Witness NFT is a digital collectible card that captures a traveler's defining moment at a place. It can be issued as a physical card linked to the digital version, and card trading between users is on the way. The QR code on the back lets anyone verify its authenticity, and it appears as an NFT badge on the map. Keep the memory of your journey in a one-of-a-kind card that belongs only to you.",
            example: "Example",
            eiffelTower: "Eiffel Tower",
            newWitness: "New witness",
            reactionsLabel: "Reactions (Likes & Curation)",
            enough: "Enough",
            minted: "Minted",
            internalNote:
                "Internally, reactions are converted to scores used for selection criteria.",
        },
        earn: {
            kicker: "FOR HIVE USERS",
            title: "A proposal from Percent Map to Hive users",
            subtitle: "Your best posts shouldn't stop earning after 7 days. On Percent Map, every like keeps adding to your rewards.",
            step1Tag: "Rewards Accumulate",
            step1Title: "Every like adds more Hive",
            step1Desc: "Each heart on your post adds to your Hive reward balance. As long as your post is alive, the rewards keep coming.",
            step1Hint: "Link your Hive account to Percent Map and your rewards will keep stacking with every like you receive.",
            step2Tag: "Claim Anytime",
            step2Title: "Send your accumulated Hive to your wallet",
            step2Desc: "Open Profile → Rewards tab to check your balance, then Claim to transfer it to your Hive wallet within 4 weeks.",
        },
        faq: {
            kicker: "FAQ",
            title: "Frequently Asked Questions",
            subtitle: "Starting with what early users wonder most.",
        },
        contact: {
            kicker: "CONTACT",
            title: "Get in Touch",
            subtitle: "Have a question? We'd love to hear from you.",
            emailLabel: "Reply-to Email",
            emailPlaceholder: "your@email.com",
            subjectLabel: "Subject",
            subjectPlaceholder: "Enter your subject",
            contentLabel: "Message",
            contentPlaceholder: "Describe your inquiry in detail",
            submit: "Send Message",
            sending: "Sending...",
            successTitle: "Message received!",
            successBody: "We'll get back to you at the email you provided as soon as possible.",
            errorTitle: "Failed to send",
            errorBody: "Please try again in a moment.",
            required: "Please fill in all required fields.",
        },
        footer: {
            tagline: "Real Map for Real Travelers",
        },
        // i18n.en 아래에 추가
        legal: {
            common: {
                privacyTitle: "Privacy Policy",
                termsTitle: "Terms of Service",
                effectiveDateLabel: "Effective Date",
                lastUpdatedLabel: "Last Updated",
                contactLabel: "Contact",
                contactEmail: "support@percentmap.com",
                langKo: "KOR",
                langEn: "ENG",
            },
            privacy: {
                intro:
                    "This policy explains how Percent Map (the “Service”) handles your personal data.",
                sections: [
                    {
                        title: "1. Data We Collect",
                        body: [
                            "Account and profile: Firebase user identifier, email, name, username, profile photo, and sign-in method (email, Google, Apple, or Facebook).",
                            "Location data: With your consent, we process location and place data to provide maps, nearby places, and location-linked posts.",
                            "User content: Posts, comments, photos, likes, collections, reports, and service usage records.",
                            "Hive linking (optional): We may collect Hive account information and key data (e.g., Hive private key) to enable rewards and synchronization.",
                            "Device and usage data: Push notification tokens, access logs, device information, errors, and security records.",
                            "Support: Reply email, username, sign-in method, and request details when you contact support or request account deletion.",
                        ],
                    },
                    {
                        title: "2. Purpose of Use",
                        body: [
                            "Account authentication and management",
                            "Providing map-based features (place-linked posts, etc.)",
                            "Hive linking and reward distribution (internal logic and Hive mechanisms)",
                            "Security, fraud prevention, and service stability",
                            "Customer support and notices",
                        ],
                    },
                    {
                        title: "3. Notice on Hive (Blockchain) Characteristics",
                        body: [
                            "If Hive Sync is enabled, your posts may be recorded on the Hive blockchain.",
                            "Due to blockchain characteristics, records may be permanent and deletion/modification may be limited.",
                            "Synced posts may appear on external services (e.g., hive.blog) and could become public even if you did not intend it.",
                        ],
                    },
                    {
                        title: "4. Storage & Protection of Hive Keys",
                        body: [
                            "Sensitive key data (e.g., Hive private key) is stored encrypted in our server database.",
                            "Keys are used only to the extent necessary to provide linking/signing/reward-related features.",
                            "You may request unlinking or deletion of keys; however, data already recorded on-chain may not be removable.",
                        ],
                    },
                    {
                        title: "5. Third-Party Services and Processors",
                        body: [
                            "Firebase (Google): Authentication, push notifications, and service operations.",
                            "Google, Apple, and Facebook: Social authentication selected by the user.",
                            "Google Maps Platform: Maps, place search, and location-based screens.",
                            "AWS (including S3 and SES): Image storage, support email delivery, and infrastructure operations.",
                            "Hive and Steem blockchains: Content synchronization and reward-related transactions when enabled by the user.",
                            "OpenAI: Inputs and generation requests when the user chooses to use an applicable generation feature.",
                            "Each provider may process data under its own privacy policy and applicable law.",
                        ],
                    },
                    {
                        title: "6. Rewards & Policy Changes",
                        body: [
                            "Rewards may be distributed according to internal logic when Hive rewards occur.",
                            "If your Hive account is linked, rewards may be distributed automatically under Hive mechanisms.",
                            "Policy changes will be announced on our website. For inquiries, contact the email below.",
                        ],
                    },
                    {
                        title: "7. Retention & Deletion",
                        body: [
                            "Account-linked data in the operational database—including profile, email, location, photos, push tokens, posts, and comments—is deleted when account deletion is completed.",
                            "Backup copies expire progressively within 30 days after deletion.",
                            "Access and security logs are retained for up to 90 days for security and abuse prevention.",
                            "Account deletion request and processing records are retained for one year to demonstrate completion and handle disputes.",
                            "Where applicable law requires retention, only the required data is separated and retained for the statutory period.",
                            "Data already recorded on the Hive or Steem blockchain may not be removable due to the technical nature of public blockchains.",
                        ],
                    },
                    {
                        title: "8. Your Rights and Account Deletion",
                        body: [
                            "You can delete your account in the app settings or submit a request through our web account deletion page (/account-deletion).",
                            "Web requests are processed within seven days after identity verification, and the result is sent to the email provided.",
                            "Upon deletion, we delete the Firebase Authentication account and account-linked app data and request deletion or token revocation from applicable third-party services.",
                        ],
                    },
                    {
                        title: "9. Data Controller and Contact",
                        body: [
                            "Data controller: John Kim",
                            "Privacy and support inquiries: support@percentmap.com",
                        ],
                    },
                    {
                        title: "10. Users Under 14",
                        body: [
                            "Percent Map does not permit account registration by children under 14.",
                            "A birth date entered during registration is used only on the device to determine eligibility and is not transmitted to or stored on our server.",
                            "An account may be restricted or terminated if it was created using false age information.",
                        ],
                    },
                ],
            },
            terms: {
                title: "Terms of Service",
                updatedAtLabel: "Effective Date",
                updatedAt: "YYYY-MM-DD",

                sections: [
                    {
                        heading: "1. Purpose",
                        body: [
                            "These Terms of Service govern the rights, obligations, and responsibilities between Percent Map (“the Service”) and its users regarding the use of travel recording, posting, map-based features, and Hive integration services.",
                        ],
                    },
                    {
                        heading: "2. Account Registration and Sign-In",
                        body: [
                            "Users may register using email sign-in or supported social login methods.",
                            "Only users aged 14 or older may register. We check registration eligibility using the birth date entered during sign-up.",
                            "Registration or account access may be denied if a user is under 14 or provides false age information.",
                            "Users must provide accurate and up-to-date information and are responsible for maintaining the security of their accounts.",
                            "Accounts may not be transferred or shared with others.",
                        ],
                    },
                    {
                        heading: "3. User Content and Responsibility",
                        body: [
                            "Users are solely responsible for the content they post, upload, or share through the Service, including text, images, and location data.",
                            "The Service may remove, restrict, or disable access to content that violates laws, infringes on third-party rights, or breaches Service policies, without prior notice.",
                            "The Service does not guarantee the accuracy, reliability, or legality of user-generated content.",
                        ],
                    },
                    {
                        heading: "4. Hive Integration & On-Chain Records (Important)",
                        body: [
                            "When Hive integration is enabled, user content or activity may be recorded on the Hive blockchain.",
                            "Due to the nature of blockchain technology, on-chain records may be permanent and deletion or modification may be limited.",
                            "Content recorded on-chain may be publicly visible on external platforms such as hive.blog, which is beyond the Service’s control.",
                            "Users must understand and agree to these characteristics before enabling Hive integration.",
                        ],
                    },
                    {
                        heading: "5. Rewards Policy",
                        body: [
                            "Rewards are calculated and distributed based on Hive blockchain rewards and the Service’s internal policies.",
                            "If a Hive account is linked, rewards may be automatically distributed according to Hive blockchain mechanisms.",
                            "Reward policies, criteria, and distribution methods may change depending on operational conditions, and such changes will be announced on the Service website.",
                            "In cases of fraudulent activity or policy violations, the Service may restrict, revoke, or reclaim rewards and limit account access.",
                        ],
                    },
                    {
                        heading: "6. Use of Posts via @percentmap Service Account",
                        body: [
                            "User posts may be uploaded to the Hive blockchain via the @percentmap service account as part of the procedures necessary for service operation, including continuous reward distribution.",
                            "This process may occur without prior individual notice and is an essential procedure for the ongoing operation of the in-app reward mechanism.",
                            "By using the in-app reward system, you are deemed to have consented to this procedure. If you do not agree, access to the Service may be restricted.",
                        ],
                    },
                    {
                        heading: "7. Service Changes and Suspension",
                        body: [
                            "The Service may modify or suspend all or part of its features as necessary for operational or technical reasons.",
                            "Significant changes or suspensions will be announced in advance through the Service website or official notices.",
                        ],
                    },
                    {
                        heading: "8. Disclaimer",
                        body: [
                            "The Service limits its liability, to the extent permitted by law, for damages caused by factors beyond its control, including blockchain network issues, exposure on external platforms, communication failures, or third-party actions.",
                            "The Service is not responsible for consequences arising from a user’s decision to enable Hive integration or on-chain recording.",
                        ],
                    },
                    {
                        heading: "9. Governing Law and Dispute Resolution",
                        body: [
                            "These Terms are governed by the laws of the Republic of Korea.",
                            "Any disputes shall be resolved in accordance with applicable civil procedure laws and jurisdiction.",
                        ],
                    },
                    {
                        heading: "10. Account Termination and Data Deletion",
                        body: [
                            "Users may request account deletion at any time through the app settings or the web account deletion page.",
                            "When deletion is completed, account-linked data—including profile, email, location, photos, push tokens, posts, and comments in the app database—is deleted.",
                            "Content and transactions already recorded on the Hive or Steem blockchain may not be removable or editable due to the nature of public blockchains.",
                            "Detailed processing and retention periods are governed by the Privacy Policy.",
                        ],
                    },
                    {
                        heading: "11. Effective Date",
                        body: ["These Terms shall take effect from the date announced on the Service website."],
                    },
                ],
            },
        },

    },
} as const;

/* ─── Hero description (JSX with highlights) ─── */
export function HeroDesc({ lang }: { lang: Lang }) {
    if (lang === "ko") {
        return (
            <p className="mt-5 max-w-xl text-base leading-relaxed text-white/80 md:text-lg">
                여행 중 올린 게시물에 사람들이 좋아요를 누르면,{" "}
                <span className="text-white">Hive 크립토 보상</span>으로 연결됩니다.
                한 장소에서 가장 인정받은 여행자는 그곳의{" "}
                <span className="text-white">장소증인</span>이 되고,{" "}
                <span className="text-white">Witness NFT 카드</span>가 발급됩니다.
                여행하고, 보상받고, 나만의 장소를 차지하세요.
                <br /><br />
                <span className="text-white/60 text-sm">
                    기존 Hive는 7일 후 보상이 끝납니다. Percent Map은 좋아요가 이어지는 한 보상도 이어집니다.
                </span>
            </p>
        );
    }
    return (
        <p className="mt-5 max-w-xl text-base leading-relaxed text-white/80 md:text-lg">
            Post while traveling — every like on your post connects to{" "}
            <span className="text-white">Hive crypto rewards</span>.
            The most recognized traveler at a place becomes its{" "}
            <span className="text-white">Place Witness</span> and receives a{" "}
            <span className="text-white">Witness NFT card</span>.
            Travel, earn, and claim your spot.
            <br /><br />
            <span className="text-white/60 text-sm">
                Standard Hive stops rewarding after 7 days. On Percent Map, rewards keep coming as long as likes do.
            </span>
        </p>
    );
}

/* ─── Rewards subtitle (JSX with highlight) ─── */
export function RewardsSubtitle({ lang }: { lang: Lang }) {
    if (lang === "ko") {
        return (
            <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-white/70">
                Percent Map에서는 여행을 기록한 사람도, 좋은 여행을 발견한
                사람도{" "}
                <span className="text-white/90">반응(좋아요·큐레이션)</span>을
                통해 함께 보상받습니다.
            </p>
        );
    }
    return (
        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-white/70">
            On Percent Map, both the person who records travel and the person
            who discovers great travel are rewarded together through{" "}
            <span className="text-white/90">reactions (likes & curation)</span>.
        </p>
    );
}

/* ─── Witness description (JSX with highlights) ─── */
export function WitnessDesc({ lang }: { lang: Lang }) {
    if (lang === "ko") {
        return (
            <p className="mt-3 text-sm leading-relaxed text-white/70">
                특정 장소에서 작성한 게시물이{" "}
                <span className="text-white">반응(좋아요·큐레이션)</span>을
                충분히 얻으면{" "}
                <span className="text-white">
                    그 장소의 Place Witness(장소증인)
                </span>
                가 됩니다. 선정되면{" "}
                <span className="text-white">Witness NFT</span>가 발급되고,
                지도에 NFT 배지가 표시됩니다.
            </p>
        );
    }
    return (
        <p className="mt-3 text-sm leading-relaxed text-white/70">
            When your post at a specific place receives enough{" "}
            <span className="text-white">reactions (likes & curation)</span>,
            you become{" "}
            <span className="text-white">that place's Place Witness</span>.
            Upon selection, a <span className="text-white">Witness NFT</span>{" "}
            is minted and an NFT badge appears on the map.
        </p>
    );
}

/* ─── Witness competition description (JSX with highlights) ─── */
export function CompetitionDesc({ lang }: { lang: Lang }) {
    if (lang === "ko") {
        return (
            <p className="mt-2 text-sm leading-relaxed text-white/70">
                Place Witness 기본 유효기간은 1년이지만,{" "}
                <span className="text-white">언제든 경쟁으로 탈환</span>될 수
                있습니다. 게시물 작성과 반응으로 얻는{" "}
                <span className="text-white">EXP</span>로 레벨업 하면
                <span className="text-white"> 탈환 기준이 더 높아져</span>{" "}
                방어가 강해집니다.
            </p>
        );
    }
    return (
        <p className="mt-2 text-sm leading-relaxed text-white/70">
            The default validity period for Place Witness is 1 year, but it{" "}
            <span className="text-white">
                can be overtaken through competition
            </span>{" "}
            at any time. Level up with{" "}
            <span className="text-white">EXP</span> earned from posting and
            reactions —{" "}
            <span className="text-white">
                higher levels mean a higher takeover threshold
            </span>
            , making defense stronger.
        </p>
    );
}

export function RarityDesc({ lang }: { lang: Lang }) {
    if (lang === "ko") {
        return (
            <p className="text-sm leading-relaxed text-white/70">
                Witness NFT는{" "}
                <span className="text-white">레어도가 랜덤</span>으로 결정됩니다.
                같은 장소라도 매번 다른 레어의 카드가 발급되며,{" "}
                <span className="text-white">SR · SAR · UR 같은 고레어 카드</span>를
                뽑으면 컬렉션 가치가 달라집니다. 과연 어떤 레어가 나올까요?
            </p>
        );
    }
    return (
        <p className="text-sm leading-relaxed text-white/70">
            Every Witness NFT comes with a{" "}
            <span className="text-white">randomly drawn rarity</span>.
            The same location can yield a completely different card each time —
            pull a{" "}
            <span className="text-white">SR, SAR, or UR</span> and your
            collection value soars. What rarity will you draw?
        </p>
    );
}

/* ─── FAQ items (JSX with links) ─── */
export function getFaqItems(lang: Lang): { q: string; a: React.ReactNode }[] {
    if (lang === "ko") {
        return [
            {
                q: "하이브(Hive)란 무엇인가요?",
                a: (
                    <>
                        하이브는{" "}
                        <span className="text-white/85 font-semibold">
                            콘텐츠 활동에 보상이 연결되는 블록체인 생태계
                        </span>
                        입니다.
                        <br />
                        <br />
                        글을 쓰거나, 좋은 콘텐츠에 반응을 남기면 그 기여가
                        기록되고 보상으로 이어지는 구조를 가지고 있어요. Percent
                        Map은 이런 하이브의 특성을 활용해{" "}
                        <span className="text-white/85 font-semibold">
                            여행 기록과 보상이 자연스럽게 연결되는 경험
                        </span>
                        을 만들고 있습니다.
                        <br />
                        <br />
                        처음에는 그냥{" "}
                        <span className="text-white/85 font-semibold">
                            "보상이 쌓이는 기반 시스템"
                        </span>{" "}
                        정도로 이해해도 충분합니다 🙂
                        <br />
                        <br />
                        <span className="text-white/70">
                            더 자세한 설명은 아래 링크를 참고해 주세요.
                        </span>
                        <div className="mt-3 flex flex-col gap-2 text-sm">
                            <a
                                href="https://hive.io/"
                                target="_blank"
                                rel="noreferrer"
                                className="text-white/80 underline decoration-white/30 underline-offset-4 hover:decoration-white/60"
                            >
                                • Hive 공식 소개 (hive.io)
                            </a>
                            <a
                                href="https://hive.blog/faq.html"
                                target="_blank"
                                rel="noreferrer"
                                className="text-white/80 underline decoration-white/30 underline-offset-4 hover:decoration-white/60"
                            >
                                • Hive.blog 공식 FAQ
                            </a>
                        </div>
                    </>
                ),
            },
            {
                q: "하이브 계정은 꼭 만들어야 하나요?",
                a: (
                    <>
                        꼭 그렇지는 않습니다 🙂
                        <br />
                        <br />
                        이미 하이브 계정이 있는 분들은{" "}
                        <span className="text-white/85 font-semibold">
                            아이디를 연동
                        </span>
                        해서 바로 사용할 수 있고, 계정 없이 먼저 앱을 사용해볼
                        수도 있어요.
                        <br />
                        <br />
                        다만 보상을{" "}
                        <span className="text-white/85 font-semibold">
                            내 지갑으로 받아 보관/사용
                        </span>
                        하려면 하이브 계정이 있으면 좋아요. 필요해지면 나중에
                        만들어서 연결해도 충분합니다.
                    </>
                ),
            },
            {
                q: "하이브 계정은 앱에서 어떻게 연결하나요?",
                a: (
                    <>
                        앱에서 하이브 계정을 연결하는 방법이에요.
                        <br /><br />
                        <span className="text-white/85 font-semibold">
                            프로필 {">"} 설정(Settings) {">"} HIVE 계정정보(HIVE Account Info)
                        </span>
                        에서{" "}
                        <span className="text-white/85 font-semibold">Account ID</span>와{" "}
                        <span className="text-white/85 font-semibold">Private Posting Key</span>를 입력하면 돼요.
                        <br /><br />
                        <span className="text-white/60 text-sm">
                            ※ 입력한 키는 암호화되어 안전하게 보관됩니다.
                        </span>
                        <div className="mt-4 flex justify-center">
                            <div className="w-48 overflow-hidden rounded-xl border border-white/10">
                                <img
                                    src={hiveSettingKoImg}
                                    alt="HIVE 계정 설정 화면"
                                    className="block w-full object-cover"
                                    draggable={false}
                                />
                            </div>
                        </div>
                    </>
                ),
            },
            {
                q: "하이브 계정은 어떻게 만드나요?",
                a: (
                    <>
                        아래 링크에서 가입하면 됩니다. 일반적으로{" "}
                        <span className="text-white/85 font-semibold">
                            Free
                        </span>{" "}
                        옵션으로 생성하면 충분합니다 👍
                        <br />
                        <br />
                        <a
                            href="https://signup.hive.io/"
                            target="_blank"
                            rel="noreferrer"
                            className="text-white/85 underline decoration-white/30 underline-offset-4 hover:decoration-white/60"
                        >
                            https://signup.hive.io/
                        </a>
                    </>
                ),
            },
            {
                q: "보상은 언제, 어떻게 받을 수 있나요?",
                a: (
                    <>
                        여행 게시물에 사람들이 남긴{" "}
                        <span className="text-white/85 font-semibold">
                            반응(좋아요·큐레이션)
                        </span>
                        과 활동 기여도를 기준으로 보상이 쌓입니다.
                        <br />
                        <br />
                        보상 지급 시점과 방식은 서비스 운영 정책에 따라
                        정해지며, 앱 내 안내를 통해 확인할 수 있어요.
                        <br />
                        <br />
                        누적된 보상은{" "}
                        <span className="text-white/85 font-semibold">
                            프로필 → 리워드 탭
                        </span>
                        에서 확인하고, Claim 버튼을 눌러 내 Hive 지갑으로 수령할 수 있습니다. 전송은 4주 이내에 처리됩니다.
                        <div className="mt-4 flex justify-center gap-3">
                            <div className="w-48 overflow-hidden rounded-xl border border-white/10">
                                <img src={rewardClaim1KoImg} alt="리워드 탭" className="block w-full object-cover" draggable={false} />
                            </div>
                            <div className="w-48 overflow-hidden rounded-xl border border-white/10">
                                <img src={rewardClaim2KoImg} alt="리워드 클레임" className="block w-full object-cover" draggable={false} />
                            </div>
                        </div>
                    </>
                ),
            },
            {
                q: "좋아요(하트)는 어떤 기능인가요?",
                a: (
                    <>
                        하트 하나는{" "}
                        <span className="text-white/85 font-semibold">
                            하이브 블록체인에서 투표력 100%를 사용한 풀보팅
                        </span>
                        과 동일해요. 좋은 게시물에 하트를 주면 작성자가 하이브
                        토큰을 보상받고, 나도 큐레이션 보상을 받을 수 있어요.
                        <br />
                        <br />
                        <span className="text-white/85 font-semibold">
                            하루 최대 10개
                        </span>
                        까지 사용할 수 있어요. 매일 좋은 여행 게시물을 발굴하고
                        하트를 나눠보세요 💰
                        <br />
                        <br />
                        <span className="text-white/60 text-sm">
                            ※ 운영 정책상 한 번 사용한 하트는 취소할 수 없어요.
                        </span>
                    </>
                ),
            },
            {
                q: "하트는 어떻게 충전되나요?",
                a: (
                    <>
                        계정 유형에 따라 충전 방식이 달라요.
                        <br />
                        <br />
                        <span className="text-white/70 text-sm">
                            🧑 일반 계정: 매일 00시에 10개가 자동으로 충전돼요.
                            <br />
                            <br />
                            ⚙️ 하이브 계정 연결: 하이브 보팅 파워(VP)와 연동돼
                            충전돼요. 하트 1개 = 풀보팅 1회 = VP 약 2% 소모예요.
                            하루 10번 모두 사용하면 VP가 100%에서 80%로 내려가고,
                            하이브는 하루 약 20%씩 자동 회복하기 때문에 다음날이면
                            다시 100%가 돼요. 즉, 매일 최대 10개를 지속적으로 사용할
                            수 있는 구조예요.
                            <br />
                            <br />앱 외부(다른 하이브 서비스 등)에서 보팅한 경우
                            그만큼 VP가 차감되므로 사용 가능한 하트 수가 줄어들
                            수 있어요.
                        </span>
                    </>
                ),
            },
            {
                q: "일반 하이브 보상과는 뭐가 다른가요?",
                a: (
                    <>
                        일반 하이브는 게시물 작성 후{" "}
                        <span className="text-white/85 font-semibold">
                            약 7일 뒤 보상이 단 한 번 지급
                        </span>
                        됩니다. 아무리 좋은 여행 기록이라도 보상이 1회로
                        끝난다는 건 아쉬운 구조예요.
                        <br />
                        <br />
                        Percent Map에서는 게시물에{" "}
                        <span className="text-white/85 font-semibold">
                            하트가 쌓일 때마다 보상이 계속 발생
                        </span>
                        합니다. 쌓인 하이브는 프로필에서 확인할 수 있고,
                        원할 때 언제든{" "}
                        <span className="text-white/85 font-semibold">
                            클레임하여 내 지갑으로 전송
                        </span>
                        받을 수 있어요. 좋은 여행 기록은 시간이 지나도
                        계속 보상받아야 한다고 생각합니다.
                    </>
                ),
            },
            {
                q: "Place Witness(장소증인)는 어떻게 선정되나요?",
                a: (
                    <>
                        특정 장소에서 남긴 여행 기록이{" "}
                        <span className="text-white/85 font-semibold">
                            사람들의 반응을 꾸준히 얻으면
                        </span>{" "}
                        그 장소를 대표하는 여행자로 선정될 수 있어요.
                        <br />
                        <br />
                        선정되면{" "}
                        <span className="text-white/85 font-semibold">
                            추가 보상과 Witness NFT
                        </span>
                        가 함께 주어집니다.
                    </>
                ),
            },
            {
                q: "컬렉션 공유는 어떻게 사용할 수 있나요?",
                a: (
                    <>
                        여행 기록을 폴더(컬렉션)로 정리하고,{" "}
                        <span className="text-white/85 font-semibold">
                            친구를 초대해 함께
                        </span>{" "}
                        사용할 수 있어요.
                        <br />
                        <br />
                        편집 권한/보기 전용 공유도 가능합니다.
                    </>
                ),
            },
        ];
    }

    return [
        {
            q: "What is Hive?",
            a: (
                <>
                    Hive is a{" "}
                    <span className="text-white/85 font-semibold">
                        blockchain ecosystem where content activity is connected
                        to rewards
                    </span>
                    .
                    <br />
                    <br />
                    When you write posts or react to good content, your
                    contributions are recorded and lead to rewards. Percent Map
                    leverages these characteristics to create{" "}
                    <span className="text-white/85 font-semibold">
                        an experience where travel records and rewards are
                        naturally connected
                    </span>
                    .
                    <br />
                    <br />
                    To start, just think of it as{" "}
                    <span className="text-white/85 font-semibold">
                        "the underlying system where rewards accumulate"
                    </span>{" "}
                    🙂
                    <br />
                    <br />
                    <span className="text-white/70">
                        For more details, check out the links below.
                    </span>
                    <div className="mt-3 flex flex-col gap-2 text-sm">
                        <a
                            href="https://hive.io/"
                            target="_blank"
                            rel="noreferrer"
                            className="text-white/80 underline decoration-white/30 underline-offset-4 hover:decoration-white/60"
                        >
                            • Hive official site (hive.io)
                        </a>
                        <a
                            href="https://hive.blog/faq.html"
                            target="_blank"
                            rel="noreferrer"
                            className="text-white/80 underline decoration-white/30 underline-offset-4 hover:decoration-white/60"
                        >
                            • Hive.blog official FAQ
                        </a>
                    </div>
                </>
            ),
        },
        {
            q: "Do I need a Hive account?",
            a: (
                <>
                    Not necessarily 🙂
                    <br />
                    <br />
                    If you already have a Hive account, you can{" "}
                    <span className="text-white/85 font-semibold">
                        link your ID
                    </span>{" "}
                    and start using it right away. You can also try the app
                    first without an account.
                    <br />
                    <br />
                    However, if you want to{" "}
                    <span className="text-white/85 font-semibold">
                        receive rewards in your own wallet
                    </span>
                    , having a Hive account is helpful. You can always create
                    and connect one later.
                </>
            ),
        },
        {
            q: "How do I connect my Hive account in the app?",
            a: (
                <>
                    Here's how to link your Hive account in the app.
                    <br /><br />
                    Go to{" "}
                    <span className="text-white/85 font-semibold">
                        Profile {">"} Settings {">"} HIVE Account Info
                    </span>{" "}
                    and enter your{" "}
                    <span className="text-white/85 font-semibold">Account ID</span>{" "}
                    and{" "}
                    <span className="text-white/85 font-semibold">Private Posting Key</span>.
                    <br /><br />
                    <span className="text-white/60 text-sm">
                        ※ Your key is encrypted and stored securely.
                    </span>
                    <div className="mt-4 flex justify-center">
                        <div className="w-48 overflow-hidden rounded-xl border border-white/10">
                            <img
                                src={hiveSettingEnImg}
                                alt="HIVE account settings screen"
                                className="block w-full object-cover"
                                draggable={false}
                            />
                        </div>
                    </div>
                </>
            ),
        },
        {
            q: "How do I create a Hive account?",
            a: (
                <>
                    You can sign up at the link below. The{" "}
                    <span className="text-white/85 font-semibold">Free</span>{" "}
                    option is usually sufficient 👍
                    <br />
                    <br />
                    <a
                        href="https://signup.hive.io/"
                        target="_blank"
                        rel="noreferrer"
                        className="text-white/85 underline decoration-white/30 underline-offset-4 hover:decoration-white/60"
                    >
                        https://signup.hive.io/
                    </a>
                </>
            ),
        },
        {
            q: "When and how can I receive rewards?",
            a: (
                <>
                    Rewards accumulate based on{" "}
                    <span className="text-white/85 font-semibold">
                        reactions (likes & curation)
                    </span>{" "}
                    and activity contributions on your travel posts.
                    <br />
                    <br />
                    The timing and method of reward distribution is determined
                    by service operation policies and can be checked through
                    in-app notifications.
                    <br />
                    <br />
                    You can check your accumulated rewards in{" "}
                    <span className="text-white/85 font-semibold">
                        Profile → Rewards tab
                    </span>
                    , then tap Claim to transfer them to your Hive wallet. Transfers are processed within 4 weeks.
                    <div className="mt-4 flex justify-center gap-3">
                        <div className="w-48 overflow-hidden rounded-xl border border-white/10">
                            <img src={rewardClaim1EnImg} alt="Rewards tab" className="block w-full object-cover" draggable={false} />
                        </div>
                        <div className="w-48 overflow-hidden rounded-xl border border-white/10">
                            <img src={rewardClaim2EnImg} alt="Reward claim" className="block w-full object-cover" draggable={false} />
                        </div>
                    </div>
                </>
            ),
        },
        {
            q: "What's a Heart (like)?",
            a: (
                <>
                    One heart equals a{" "}
                    <span className="text-white/85 font-semibold">
                        100% upvote on the Hive blockchain
                    </span>
                    . When you heart a great post, the creator earns Hive tokens
                    — and you earn curation rewards too.
                    <br />
                    <br />
                    You can use{" "}
                    <span className="text-white/85 font-semibold">
                        up to 10 hearts per day
                    </span>
                    . Discover great travel posts every day and share the love
                    💰
                    <br />
                    <br />
                    <span className="text-white/60 text-sm">
                        ※ Per our operating policy, hearts cannot be cancelled
                        once given.
                    </span>
                </>
            ),
        },
        {
            q: "How do Hearts recharge?",
            a: (
                <>
                    It depends on your account type.
                    <br />
                    <br />
                    <span className="text-white/70 text-sm">
                        🧑 Standard account: 10 hearts are automatically
                        refilled at midnight every day.
                        <br />
                        <br />
                        ⚙️ Hive-linked account: Hearts are synced with your
                        Hive Voting Power (VP). Each heart = 1 full-power vote
                        = ~2% VP used. Use all 10 hearts in a day and your VP
                        drops from 100% to 80%. Hive automatically recovers
                        ~20% VP per day, so you're back to 100% by the next
                        day — making 10 hearts per day sustainably repeatable.
                        <br />
                        <br />
                        If you vote outside the app (on other Hive services),
                        that VP is deducted too, so your available hearts may
                        be lower.
                    </span>
                </>
            ),
        },
        {
            q: "How is this different from regular Hive rewards?",
            a: (
                <>
                    On standard Hive, rewards are paid out{" "}
                    <span className="text-white/85 font-semibold">
                        just once — about 7 days after posting
                    </span>
                    . Even the best travel post stops earning after that
                    single payout. That feels like a missed opportunity.
                    <br />
                    <br />
                    On Percent Map,{" "}
                    <span className="text-white/85 font-semibold">
                        every heart earns you more Hive
                    </span>
                    — as long as people keep liking your post, rewards keep
                    accumulating. You can track the balance in your profile
                    and{" "}
                    <span className="text-white/85 font-semibold">
                        claim it to your wallet whenever you want
                    </span>
                    . Great travel content deserves to keep earning.
                </>
            ),
        },
        {
            q: "How is a Place Witness selected?",
            a: (
                <>
                    When your travel records at a specific place{" "}
                    <span className="text-white/85 font-semibold">
                        consistently receive reactions from others
                    </span>
                    , you can be selected as the representative traveler for
                    that place.
                    <br />
                    <br />
                    Upon selection, you receive{" "}
                    <span className="text-white/85 font-semibold">
                        additional rewards and a Witness NFT
                    </span>
                    .
                </>
            ),
        },
        {
            q: "How do I use collection sharing?",
            a: (
                <>
                    Organize your travel records into folders (collections) and{" "}
                    <span className="text-white/85 font-semibold">
                        invite friends to use them together
                    </span>
                    .
                    <br />
                    <br />
                    Edit permissions and view-only sharing are also available.
                </>
            ),
        },
    ];
}
